module.exports = __webpack_public_path__ + "static/media/Kent Kitchen  (5).e34333cc.JPG";